export default __webpack_public_path__ + "static/media/portfolio-194.4002bac6.jpg";